import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';
import HomeFAQ from './components/HomeFAQ';
import { featuredComics, latestUpdates, popularRanking, categories } from '@/mocks/home';

export default function Home() {
  const organizationSchema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫网',
    url: 'https://thingschat.cn',
    description: '韩漫网提供综合服务，实现韩漫在线观看与漫画免费下拉式阅读，好看韩国漫画全集内容丰富。',
    sameAs: ['https://weibo.com/hanmanwang', 'https://weixin.qq.com/hanmanwang'],
  }), []);

  const websiteSchema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫网',
    url: 'https://thingschat.cn',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://thingschat.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  }), []);

  const webpageSchema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫在线观看-漫画免费下拉式阅读-好看的韩国漫画全集-韩漫网',
    description: '韩漫网提供综合服务，实现韩漫在线观看与漫画免费下拉式阅读，好看韩国漫画全集内容丰富。',
    url: 'https://thingschat.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'https://thingschat.cn',
    },
  }), []);

  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" data={organizationSchema} />
      <SEOSchema type="WebSite" data={websiteSchema} />
      <SEOSchema type="WebPage" data={webpageSchema} />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection categories={categories} />
        <FeaturedComics comics={featuredComics} />
        <PopularRanking comics={popularRanking} />
        <LatestUpdates comics={latestUpdates} />
        <HomeFAQ />
      </main>

      <Footer />
    </>
  );
}